import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1xs6,
    GridItem2xs6,
    GridItem3xs6,
    GridItem7xs12,
    GridItem8xs12,
    GridItem11xs6,
} from '../../../business-components/Grid/Grid'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorValor,
    TextValidatorValorRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldNumberSelect,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import {
    grupoCoberturaSeguroVidaList
 } from '../../../business-rules/List/SeguroVida/grupoCoberturaSeguroVidaList'

import tipoCoberturaSeguroVidaList from '../../../business-rules/List/SeguroVida/tipoCoberturaSeguroVidaList'

import tipoPrazoRecebtoRendaCoberturaSeguroVidaList from '../../../business-rules/List/tipoPrazoRecebtoRendaCoberturaSeguroVidaList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
 } from '../../../business-components/Button/Button'

import {
    incrementaContSeguroVidaCotacaoCobertura,
} from './SeguroVidaCotacaoServiceCobertura'

import {
    processaAlteracaoSeguroVidaCoberturaTipoCoberturaSeguroVida
} from '../seguroVida-form/SeguroVidaServiceSeguroVidaCobertura'



const SeguroVidaCotacaoFormCobertura = ({ idSeguroVidaCotacao, integracao, values, handleChange, setFieldValue }) => {
    
    let tipoCoberturaSeguroVidaSelecionado = ''

    return (
        <FieldArray name="seguroVidaCotacaoCobertura">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm
                        style={{
                            display: values.seguroVidaCotacaoCobertura && values.seguroVidaCotacaoCobertura.filter(seguroVidaCotacaoCobertura => seguroVidaCotacaoCobertura.idSeguroVidaCotacao === idSeguroVidaCotacao).length > 0 ? "block" : "none"
                        }}
                    >
                        {values.seguroVidaCotacaoCobertura?.map((item, ind) => {
                            
                            tipoCoberturaSeguroVidaSelecionado = pesquisaList(tipoCoberturaSeguroVidaList, 
                                item.tipoCoberturaSeguroVida)

                            if (!item.dataTerminoCobertura) {

                                item.dataTerminoCobertura = null
                            }

                            return item.idSeguroVidaCotacao === idSeguroVidaCotacao ? (
                                <GridContainer
                                    key={ind}
                                >
                                    <GridItem2xs6>
                                        <TextFieldNumberSelect
                                            name={`seguroVidaCotacaoCobertura[${ind}].grupoCoberturaSeguroVida`}
                                            label={LABEL.grupoCoberturaSeguroVida}
                                            value={item.grupoCoberturaSeguroVida === 0 ? 0 : item.grupoCoberturaSeguroVida || ''}
                                            onChange={handleChange}
                                            list={grupoCoberturaSeguroVidaList}
                                        />
                                    </GridItem2xs6>
                                    <GridItem2xs6>
                                        <TextFieldNumberSelect
                                            name={`seguroVidaCotacaoCobertura[${ind}].tipoCoberturaSeguroVida`}
                                            label={LABEL.tipoCoberturaSeguroVida}
                                            value={item.tipoCoberturaSeguroVida || ''}
                                            onChange={handleChange}
                                            list={tipoCoberturaSeguroVidaList.filter(linhaTipoCoberturaSeguroVidaList => 
                                                linhaTipoCoberturaSeguroVidaList.grupoCoberturaSeguroVida === item.grupoCoberturaSeguroVida)}
                                            onBlur={processaAlteracaoSeguroVidaCoberturaTipoCoberturaSeguroVida(item)}
                                        />
                                    </GridItem2xs6>
                                    <GridItem8xs12>
                                        <GridContainer>
                                            {item.tipoCoberturaSeguroVida
                                                ?
                                                    <>
                                                        <GridItem2xs6>
                                                            <TextValidatorValorRequired
                                                                name={`seguroVidaCotacaoCobertura[${ind}].valorCS`}
                                                                label={tipoCoberturaSeguroVidaSelecionado.tipoValorInformado === "CS"
                                                                    ? LABEL.valorCS
                                                                    : tipoCoberturaSeguroVidaSelecionado.tipoValorInformado === "Renda"
                                                                        ? LABEL.valorRenda
                                                                        : tipoCoberturaSeguroVidaSelecionado.tipoValorInformado === "Diaria"
                                                                            ? LABEL.valorDiaria
                                                                            : ""
                                                                }
                                                                value={item.valorCS === 0 ? 0 : item.valorCS || ''}
                                                                onChange={handleChange}
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6>
                                                            <TextValidatorValorRequired
                                                                name={`seguroVidaCotacaoCobertura[${ind}].valorPremio`}
                                                                label={LABEL.valorPremio}
                                                                value={item.valorPremio === 0 ? 0 : item.valorPremio || ''}
                                                                onChange={handleChange}
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display:
                                                                    tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCobertura === "S" ||
                                                                    (
                                                                        tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCoberturaOpcional === "S" &&
                                                                        item.dataTerminoCobertura
                                                                    )
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <MuiPickersUtilsProviderPadrao>
                                                                <KeyboardDatePickerPadrao
                                                                    name={`seguroVidaCotacaoCobertura[${ind}].dataTerminoCobertura`}
                                                                    label={LABEL.dataTerminoCobertura}
                                                                    value={item.dataTerminoCobertura}
                                                                    onChange={(date) => {
                                                                        setFieldValue(
                                                                            `seguroVidaCotacaoCobertura[${ind}].dataTerminoCobertura`,
                                                                            date,
                                                                        )}
                                                                    }
                                                                />
                                                            </MuiPickersUtilsProviderPadrao>
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display:
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda === "S" ||
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda === "V"
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextFieldNumberSelectRequired
                                                                name={`seguroVidaCotacaoCobertura[${ind}].tipoPrazoRecebtoRenda`}
                                                                label={LABEL.tipoPrazoRecebtoRenda}
                                                                value={item.tipoPrazoRecebtoRenda || ''}
                                                                onChange={handleChange}
                                                                list={tipoPrazoRecebtoRendaCoberturaSeguroVidaList(
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda)
                                                                }
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display: 
                                                                    tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCobertura !== "S" &&
                                                                    (
                                                                        tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCoberturaOpcional !== "S" ||
                                                                        !item.dataTerminoCobertura
                                                                    ) &&
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda !== "S" &&
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda !== "V"
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        />

                                                        <GridItem2xs6
                                                            style={{
                                                                display: 
                                                                    tipoCoberturaSeguroVidaSelecionado.informaCSSobrevivencia === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextValidatorValorRequired
                                                                name={`seguroVidaCotacaoCobertura[${ind}].valorCSSobrevivencia`}
                                                                label={LABEL.valorCSSobrevivencia}
                                                                value={item.valorCSSobrevivencia || ''}
                                                                onChange={handleChange}
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display: 
                                                                    tipoCoberturaSeguroVidaSelecionado.informaCSSobrevivencia !== "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        />

                                                        <GridItem3xs6/>
                                                    </>
                                                :
                                                    <GridItem11xs6/>
                                            }

                                            <GridItem1xs6>
                                                <IconButtonClearEntradaDados
                                                    onClick={() =>
                                                        arrayHelpers.remove(ind)
                                                    }
                                                />
                                            </GridItem1xs6>
                                        </GridContainer>

                                        {item.tipoCoberturaSeguroVida && integracao === 'S' && (
                                            <>
                                                <GridContainer>
                                                    <GridItem2xs6>
                                                        <TextValidatorValor
                                                            name={`seguroVidaCotacaoCobertura[${ind}].valorPremioLiquido`}
                                                            label={LABEL.valorPremioLiquido}
                                                            value={item.valorPremioLiquido === 0 ? 0 : item.valorPremioLiquido || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem2xs6>
                                                    <GridItem2xs6>
                                                        <TextValidatorValor
                                                            name={`seguroVidaCotacaoCobertura[${ind}].valorIof`}
                                                            label={LABEL.valorIof}
                                                            value={item.valorIof === 0 ? 0 : item.valorIof || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem2xs6>
                                                    <GridItem7xs12>
                                                        <TextValidatorText
                                                            name={`seguroVidaCotacaoCobertura[${ind}].descricaoCobertura`}
                                                            label={LABEL.descricaoCobertura}
                                                            value={item.descricaoCobertura || ''}
                                                            onChange={handleChange}
                                                            tamMax={TAMMAX.descricaoCobertura}
                                                        />
                                                    </GridItem7xs12>
                                                </GridContainer>

                                                <GridContainer>
                                                    {item.classeAjusteRisco && (
                                                        <GridItem2xs6>
                                                            <TextValidatorText
                                                                name={`seguroVidaCotacaoCobertura[${ind}].classeAjusteRisco`}
                                                                label={LABEL.classeAjusteRisco}
                                                                value={item.classeAjusteRisco || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.classeAjusteRisco}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                    {item.valorPremioExtra > 0 && (
                                                        <GridItem2xs6>
                                                            <TextValidatorValor
                                                                name={`seguroVidaCotacaoCobertura[${ind}].valorPremioExtra`}
                                                                label={LABEL.valorPremioExtra}
                                                                value={item.valorPremioExtra === 0 ? 0 : item.valorPremioExtra || ''}
                                                                onChange={handleChange}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                    {item.duracaoPremioExtra > 0 && (
                                                        <GridItem1xs6>
                                                            <TextValidatorNumber
                                                                name={`seguroVidaCotacaoCobertura[${ind}].duracaoPremioExtra`}
                                                                label={LABEL.duracaoPremioExtra}
                                                                value={item.duracaoPremioExtra === 0 ? 0 : item.duracaoPremioExtra || ''}
                                                                onChange={handleChange}
                                                                numMin={NUMMIN.duracaoPremioExtra}
                                                                numMax={NUMMAX.duracaoPremioExtra}
                                                            />
                                                        </GridItem1xs6>
                                                    )}
                                                    {item.valorRendaMensal && (
                                                        <GridItem2xs6>
                                                            <TextValidatorValor
                                                                name={`seguroVidaCotacaoCobertura[${ind}].valorRendaMensal`}
                                                                label={LABEL.valorRendaMensal}
                                                                value={item.valorRendaMensal === 0 ? 0 : item.valorRendaMensal || ''}
                                                                onChange={handleChange}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                </GridContainer>
                                            </>
                                        )}
                                    </GridItem8xs12>
                                </GridContainer>
                            )
                            :
                            (
                                <DivForm
                                    key={ind}
                                />
                            )
                        })}
                    </DivForm>

                    <ButtonIncluirLinha
                        label={LABEL.buttonIncluirSeguroVidaCobertura} 
                        onClick={() =>
                            {
                                incrementaContSeguroVidaCotacaoCobertura(values)
                                arrayHelpers.push({
                                    id: values.contSeguroVidaCotacaoCobertura,
                                    idSeguroVidaCotacao: idSeguroVidaCotacao,
                                })
                            }
                        }
                    />
                </DivForm>
            )}
        </FieldArray>
    )
}

export default SeguroVidaCotacaoFormCobertura